// extracted by mini-css-extract-plugin
module.exports = {"clinicsSelect":"Header_clinicsSelect__1l9DO"};